export default "__VITE_ASSET__DrcNgrwL__"